import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import Typography from "@mui/material/Typography";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, enAU } from "date-fns/locale";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import PersonOutline from "@mui/icons-material/PersonOutline";
import moment from "moment-timezone";
import LockIcon from "@mui/icons-material/Lock";
import { useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import { validateSecureLink } from "../_api/usersApi";
import { toast } from "react-toastify";
import ErrorIcon from "@mui/icons-material/Error";
import BadgeIcon from "@mui/icons-material/Badge";
import { SaveLoader } from "@/_components";
import { connect } from "react-redux";
import PhotoManagement from "./PhotoManagement";
import Cookies from "universal-cookie";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
    [theme.breakpoints.only("sm")]: { padding: theme.spacing(2) },
    [theme.breakpoints.down("sm")]: { paddingTop: theme.spacing(2) },
  },
  paper: {
    maxWidth: 400,
    [theme.breakpoints.down("md")]: { maxWidth: "100%" },
    // [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
    // [theme.breakpoints.down("md")]: { padding: theme.spacing(2) },
  },
  customIconUnauth: {
    color: "#1c355e",
    height: 200,
    width: 200,
    opacity: 0.1,
  },
  customTypoUnauth: {
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -180,
  },
  paperNoData: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 320,
    width: 320,
  },
  paperUpdate: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: 320,
    width: 320,
  },
  customTypoUpdate: {
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -150,
  },
  cardHeader: {
    variant: "h1",
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center",
  },
}));

const IdUpload = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const locale = countryCode === "USA" ? enUS : enAU;
  const { token } = useParams();
  const [attempts, setAttempts] = useState(0);
  const [unauthorized, setUnauthorized] = useState(false);
  const [validSuccess, setValidSuccess] = useState(false);
  const [validIdSubmit, setValidIdSubmit] = useState(false);
  const [validatedData, setValidatedData] = useState(null);
  const isMountedRef = useRef(null);
  const [submitting, setSubmitting] = useState(false);
  const cookies = new Cookies();
  const { register, errors, handleSubmit, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      lastName: null,
      dob: null,
    },
  });
    useEffect(() => {
      cookies.remove("lifesaferUser", { path: "/" });
    }, []);

  
  const onSubmit = (data) => {
    setSubmitting(true);
    let formattedDate = new Intl.DateTimeFormat("en-US")
      .format(new Date(data.dob))
      .toString();

    let validateData = {
      token: token,
      // page: "My Account Sign Now",
      page: "My Account ID Upload",
      lastName: data.lastName,
      dob: formattedDate,
    };
    validateSecureLink(validateData)
      .then((validateData) => {
        toast.success(t("toasts.updateComplete"));
        setValidatedData(validateData);
        setSubmitting(false);
        setValidSuccess(true);
        //   cookies.set("lifesaferUser", JSON.stringify(validateData), {
        //     path: "/",
        //     sameSite: "strict",
        // });
      })
      .catch((error) => {
        handleFailedAttempt();
        let errMess = error.message;
        errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
        toast.error(t("toasts.updateFailed") + " " + errMess);
        setSubmitting(false);
      });
    // console.log(validateData);
  };

  // const expireLink = async () => {
  //   try {
  //     let expireLink = {
  //       token: token,
  //       page: "My Account ID Upload",
  //     };
  //     await expireSecureLink(expireLink);
  //   } catch (error) {
  //     console.error("Failed to expire link:", error);
  //   }
  // };

  const expireLink = async () => {
    try {
      const expireLinkData = {
        token: token,
        page: "My Account ID Upload",
      };

      const response = await fetch(
        `${process.env.API_URL}/Users/ExpireSecureLink`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(expireLinkData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to expire secure link");
      }
      // const data = await response.json();
      // console.log("Secure link expired:", data);
    } catch (error) {
      console.error("Failed to expire link:", error);
      toast.error("Failed to expire secure link");
    }
  };

  const handleFailedAttempt = () => {
    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    if (newAttempts >= 3) {
      setUnauthorized(true);
      expireLink();
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (isMountedRef.current && validIdSubmit === true) {
      expireLink();
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [validIdSubmit]);

  return (
    <>
      {unauthorized ? (
        <>
          <Container sx={{ marginTop: "20px" }}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                    <img
                      src={"./src/_images/LogoLimited.png"}
                      alt="LifeSafer"
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        // padding: "1rem",
                        color: "#1c355e",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {t("account.secureIdUpload")}
                    </Typography>
                  </Grid>
              <Paper className={classes.paperNoData} elevation={2} sx={{ marginTop:"32px" }}>
                <Grid container direction="column">
                  <Grid item>
                    <Typography className={classes.cardHeader}>
                      {t("registration.unAuthorized")}
                    </Typography>
                  </Grid>
                  <Grid item style={{ marginTop: 4, textAlign: "center" }}>
                    <ErrorIcon className={classes.customIconUnauth} />
                    <Typography className={classes.customTypoUnauth}>
                      {t("registration.unAuthorizedMsg")}
                    </Typography>
                  </Grid>

                  <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    direction="column"
                    mt={2}
                  >
                    <Grid item>
                      <Button
                        type="submit"
                        size="small"
                        variant="contained"
                        color="primary"
                        // disabled={submitting}
                        className={classes.submit}
                        // style={{ width: 240, height: 50 }}
                      >
                        (800) 634-3077
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Container>
        </>
      ) : (
        <>
          {validSuccess ? (
            <>
              <Container sx={{ marginTop: "20px" }}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item>
                    <img
                      src={"./src/_images/LogoLimited.png"}
                      alt="LifeSafer"
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        // padding: "1rem",
                        color: "#1c355e",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {t("account.secureIdUpload")}
                    </Typography>
                  </Grid>
                  {!validIdSubmit && (
                    <>
                      <Grid item>
                        <Typography
                          variant="h5"
                          sx={{
                            padding: "1rem",
                            color: "#1c355e",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {t("registration.client")} :{" "}
                          {validatedData?.clientName
                            ? validatedData?.clientName
                            : "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          sx={{
                            padding: "1rem",
                            color: "#7A7B8A",
                            textAlign: "left",
                            backgroundColor: "#F0F6F7",
                            borderRadius: "4px",
                            width: "320px",
                            marginBottom: 2,
                          }}
                        >
                          {t("registration.uploadMessage")}
                        </Typography>
                      </Grid>
                    </>
                  )}

                  <Grid item mt={1} sx={{ maxWidth: "320px !important" }}>
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {!validIdSubmit ? (
                        <PhotoManagement
                          setValidIdSubmit={setValidIdSubmit}
                          validatedData={validatedData}
                        />
                      ) : (
                        <>
                          <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            mt={4}
                          >
                            <Paper
                              className={classes.paperUpdate}
                              elevation={2}
                            >
                              <Grid
                                container
                                direction="column"
                                alignItems="center"
                              >
                                <Grid item>
                                  <Typography className={classes.cardHeader}>
                                    {t("registration.uploadComplete")}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  style={{
                                    marginTop: "40px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}
                                >
                                  <BadgeIcon
                                    className={classes.customIconUnauth}
                                  />
                                  <Typography
                                    className={classes.customTypoUpdate}
                                  >
                                    {t("registration.uploadCompleteMessage")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Container>
            </>
          ) : (
            <>
              <Container sx={{ marginTop: "20px" }}>
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item>
                    <img
                      src={"./src/_images/LogoLimited.png"}
                      alt="LifeSafer"
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        // padding: "1rem",
                        color: "#1c355e",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {t("account.secureIdUpload")}
                    </Typography>
                  </Grid>

                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    mt={4}
                  >
                    <Grid item>
                      <Paper className={classes.paper} elevation={2}>
                        <Grid container style={{ paddingBottom: 20 }}>
                          <Grid item xs={12}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: "bold",
                                textAlign: "left",
                                alignItems: "center",
                                display: "flex",
                                gap: "2px",
                                padding: 2,
                              }}
                            >
                              <LockIcon
                                sx={{
                                  color: "#1c355e",
                                }}
                              />
                              {t("registration.identityVerification")}
                            </Typography>
                            <Divider />
                          </Grid>
                          <Grid item xs={12} sx={{ padding: 2 }}>
                            <form
                              className={classes.form}
                              onSubmit={handleSubmit(onSubmit)}
                            >
                              <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="lastName"
                                label={t("profile.lName")}
                                name="lastName"
                                // disabled={submitting}
                                error={!!errors.lastName}
                                helperText={
                                  errors.lastName ? errors.lastName.message : ""
                                }
                                inputRef={register({
                                  required: {
                                    value: true,
                                    message: t("profile.lastNameRequired"),
                                  },
                                })}
                                size="small"
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <PersonOutline
                                        className={classes.inputIco}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                adapterLocale={locale}
                              >
                                <Controller
                                  control={control}
                                  name="dob"
                                  rules={{
                                    required: {
                                      value: true,
                                      message: t(
                                        "registration.dateOfBirthRequired"
                                      ),
                                    },
                                    validate: (value) => {
                                      let minDate = moment().subtract(
                                        100,
                                        "years"
                                      );
                                      let maxDate = moment().subtract(
                                        14,
                                        "years"
                                      );
                                      if (value.toString() === "Invalid Date")
                                        return t(
                                          "registration.dateOfBirthInvalid"
                                        );
                                      if (value < minDate || value > maxDate) {
                                        return t(
                                          "registration.dateOfBirthInvalid"
                                        );
                                      }
                                      return true;
                                    },
                                  }}
                                  render={(props) => (
                                    <DesktopDatePicker
                                      {...props}
                                      id="dob"
                                      label={t("profile.dobLabel")}
                                      inputFormat={
                                        countryCode === "USA"
                                          ? "MM/dd/yyyy"
                                          : "dd/MM/yyyy"
                                      }
                                      disableFuture
                                      openTo="year"
                                      views={["year", "month", "day"]}
                                      // disabled={disableInputs}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          margin="normal"
                                          size="small"
                                          error={!!errors.dob}
                                          helperText={
                                            errors.dob ? errors.dob.message : ""
                                          }
                                          InputLabelProps={{ shrink: true }}
                                        />
                                      )}
                                    />
                                  )}
                                  size="small"
                                />
                              </LocalizationProvider>

                              <Grid
                                container
                                alignItems="center"
                                justifyContent="center"
                                direction="column"
                                mt={2}
                              >
                                <Grid item>
                                  {submitting === false ? (
                                    <Button
                                      type="submit"
                                      size="small"
                                      variant="contained"
                                      color="primary"
                                      // disabled={submitting}
                                      className={classes.submit}
                                      // style={{ width: 240, height: 50 }}
                                      style={{ height: 35 }}
                                      // startIcon={<CheckIcon />}
                                    >
                                      {t("registration.verify")}
                                    </Button>
                                  ) : (
                                    <SaveLoader />
                                  )}
                                </Grid>
                              </Grid>
                            </form>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Container>
            </>
          )}
        </>
      )}
    </>
  );
};

IdUpload.propTypes = {};
function mapStateToProps() {
  return {};
}
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(IdUpload);
